"use client";

import dynamic from "next/dynamic";
import { useEffect, useState } from "react";

const DeferredGoogleTagManager = dynamic(
    async () => (await import("@next/third-parties/google")).GoogleTagManager,
    { ssr: false },
);
const DeferredLeadSourceTracker = dynamic(() => import("@/components/LeadSourceTracker"), { ssr: false });
const DeferredLeadSourceDebug = dynamic(() => import("@/components/LeadSourceDebug"), { ssr: false });
const DeferredServiceCta = dynamic(() => import("@/components/ServiceCta"), { ssr: false });
const DeferredIubendaScripts = dynamic(() => import("@/components/analytics/IubendaScripts"), { ssr: false });

export default function DeferredPublicFeatures() {
    const [isSupportReady, setIsSupportReady] = useState(false);
    const [isAnalyticsReady, setIsAnalyticsReady] = useState(false);
    const [isTagManagerReady, setIsTagManagerReady] = useState(false);

    useEffect(() => {
        const activateSupport = () => setIsSupportReady(true);
        const activateAnalytics = () => setIsAnalyticsReady(true);
        const interactionOptions = { once: true, passive: true } as const;

        const supportTimeoutId = setTimeout(activateSupport, 12000);
        const analyticsTimeoutId = setTimeout(activateAnalytics, 8000);

        window.addEventListener("pointerdown", activateAnalytics, interactionOptions);
        window.addEventListener("keydown", activateAnalytics, { once: true });

        return () => {
            clearTimeout(supportTimeoutId);
            clearTimeout(analyticsTimeoutId);
            window.removeEventListener("pointerdown", activateAnalytics);
            window.removeEventListener("keydown", activateAnalytics);
        };
    }, []);

    useEffect(() => {
        if (!isAnalyticsReady) return;

        const tagManagerTimerId = setTimeout(() => {
            setIsTagManagerReady(true);
        }, 1200);

        return () => {
            clearTimeout(tagManagerTimerId);
        };
    }, [isAnalyticsReady]);

    return (
        <>
            <DeferredLeadSourceTracker />
            <DeferredLeadSourceDebug />
            {isSupportReady && <DeferredServiceCta />}
            {isAnalyticsReady && (
                <>
                    <DeferredIubendaScripts />
                    {isTagManagerReady && (
                        <>
                            <DeferredGoogleTagManager gtmId="GTM-PX9NDS6" />
                        </>
                    )}
                </>
            )}
        </>
    );
}
